export default __webpack_public_path__ + "static/media/scheduleIcon.a4e76ab0.svg";